import { SocialType } from '../enums';

export interface SocialGroup {
  type: SocialType;
  link: string;
}
